import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { AccountService } from './account.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { apiResponseFactory } from 'src/app/models/response/apiResponseFactory';
import { UgovorODjeluDto } from '../models/hr/ugovor-o-djelu.model';
import { getAcceptLanguage } from '../helpers/getAcceptLanguage';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UodService {
  constructor(
    private api: BaseApiService,
    private accountService: AccountService,
  ) { }

  getAll(): Observable<UgovorODjeluDto[]> {
    return this.api.get('uod/all').pipe(
      map((response: HttpResponse<apiResponseFactory>) => {
        if (response.status == 200 && response?.body?.result) {
          return response.body.result.map((client) => new UgovorODjeluDto(client));
        }
        return undefined;
      }),
      catchError(this.handleError<UgovorODjeluDto[]>(`getvirmaniAll`))
    );
  }

  potvrdaONaknadamaExcel(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}uod/potvrda-o-naknadama`,
      { godina: params.godina, radnik: params.radnik },
      {},
      { headers, responseType: 'blob', observe: 'response' }
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;

      return throwError(error);
    };
  }
}
